export enum OrcidScopes {
  READ_LIMITED = '/read-limited',
  ACTIVITIES_UPDATE = '/activities/update',
}
